__turbopack_context__.v({
  "bot": "style-module-scss-module__dLiiza__bot",
  "image": "style-module-scss-module__dLiiza__image",
  "item": "style-module-scss-module__dLiiza__item",
  "label": "style-module-scss-module__dLiiza__label",
  "link": "style-module-scss-module__dLiiza__link",
  "list": "style-module-scss-module__dLiiza__list",
  "service": "style-module-scss-module__dLiiza__service",
  "text": "style-module-scss-module__dLiiza__text",
  "title": "style-module-scss-module__dLiiza__title",
  "top": "style-module-scss-module__dLiiza__top",
  "wrapper": "style-module-scss-module__dLiiza__wrapper",
});
